import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrdersService } from '../../services/orders/orders.service';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { Router } from '@angular/router';
import { Helpers } from '../../../helpers';


@Component({
  selector: 'app-dmradd-order-modal',
  templateUrl: './dmradd-order-modal.component.html',
  styleUrls: ['./dmradd-order-modal.component.scss']
})
export class DMRAddOrderModalComponent implements OnInit {

  @Output() onCloseBtnClick = new EventEmitter<any>();
  @Input() BookingId:any;
  userId:any;
  CompanyId: any;
  SelectedCompanyGSTCode: any;
  TenantId: any;
  @Output() OnRefreshParent = new EventEmitter<string>();

  TransportService: any = {
    lable: 'Transport Service',
    formControlName: 'TransportService',
    dataField: 'TransportService',
    isRequired: true,
    placeholder: 'Select Transport Service',
    isValueBind: true
  };

  Customer: any = {
    lable: 'Customer',
    formControlName: 'Customer',
    dataField: 'Customer',
    isRequired: true,
    placeholder: 'Select Customer',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  VehicleType: any = {
    lable: 'Vehicle Type',
    formControlName: 'VehicleType',
    dataField: 'VehicleType',
    isRequired: true,
    placeholder: 'Select Vehicle Type',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  PickupLocation: any = {
    lable: 'From Location',
    formControlName: 'PickupLocation',
    dataField: 'PickupLocation',
    isRequired: true,
    placeholder: 'Select From Location',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  DeliveryLocation: any = {
    lable: 'To Location',
    formControlName: 'DeliveryLocation',
    dataField: 'DeliveryLocation',
    isRequired: true,
    placeholder: 'Select To Location',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  VehicleNo: any = {
    lable: 'Vehicle No',
    formControlName: 'VehicleNo',
    dataField: 'VehicleNo',
    isRequired: true,
    placeholder: 'Select Vehicle No',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  ContainerNo: any = {
    lable: 'Container No',
    formControlName: 'ContainerNo',
    dataField: 'ContainerNo',
    isRequired: false,
    placeholder: 'Enter Container No',
  };

  SealNo: any = {
    lable: 'Seal No',
    formControlName: 'SealNo',
    dataField: 'SealNo',
    isRequired: false,
    placeholder: 'Enter Seal No',
  };

  Scan: any = {
    lable: 'Scan',
    formControlName: 'Scan',
    dataField: 'Scan',
    isRequired: false,
    placeholder: 'Enter Scan',
  };

  TripDate: any = {
    lable: 'Trip Date',
    formControlName: 'TripDate',
    dataField: 'TripDate',
    isRequired: true,
    placeholder: 'Select Trip Date',
  };

  DieselTaken: any = {
    lable: 'Diesel Taken',
    formControlName: 'DieselTaken',
    dataField: 'DieselTaken',
    isRequired: false,
    placeholder: 'Enter Diesel Taken',
    type: "number",
  };

  Weight: any = {
    lable: 'Weight',
    formControlName: 'Weight',
    dataField: 'Weight',
    isRequired: false,
    placeholder: 'Enter Weight',
    type: "number",
  };

  Driver: any = {
    lable: 'Driver',
    formControlName: 'Driver',
    dataField: 'Driver',
    isRequired: false,
    placeholder: 'Select Driver',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  data: any = {};
  isFormSubmitY: boolean = false;

  orders: any[] = [
    this.createEmptyOrder()
  ];


  constructor(
    private orderService: OrdersService,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private router: Router
  ) { }

  ngOnInit() {
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.SelectedCompanyGSTCode = JSON.parse(localStorage.getItem("ChnageCompnayId")).GSTCode;
    this.TenantId = JSON.parse(
      this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId")))
    );
    this.GetTransportService();
    // this.GetDmrDataById();
  }

  createEmptyOrder() {
    return {
      TransportService: null,
      Customer: null,
      VehicleType: null,
      PickupLocation: null,
      DeliveryLocation: null,
      VehicleNo: null,
      ContainerNo: null,
      SealNo: null,
      TripDate: null,
      DieselTaken: null,
      Weight: null,
      Driver: null,
      pickupLocationField: {
      ...this.PickupLocation,
      dropdownList: [],
      isSearch: false
    }
    };
  }


  Cancel() {
    this.onCloseBtnClick.emit()
  }

  GetDmrDataById() {
    this._appService
      .GetById("Booking", "NewGetDMRDataById", this.BookingId)
      .subscribe(
        (response) => {
          console.log('GetDmrDataById response',response)
          if(response){
            this.data[this.TransportService.dataField]=response[0].TransportServiceId;
            this.data[this.VehicleType.dataField]=response[0].VehicleTypeId;
            this.data[this.PickupLocation.dataField]=response[0].Origin;
            this.data[this.DeliveryLocation.dataField]=response[0].Destination;
            this.data[this.VehicleNo.dataField]=response[0].VehicleId;
            this.data[this.ContainerNo.dataField]=response[0].ContainerNo;
            this.data[this.TripDate.dataField]=response[0].TripDate;
            this.data[this.Scan.dataField]=response[0].Scan;
            this.data[this.DieselTaken.dataField]=response[0].DieselTaken;
            this.data[this.Driver.dataField]=response[0].DriverId;

            // this.setDropdown(this.TransportService,response[0].TransportServiceId,response[0].TransportService);
            this.setDropdown(this.VehicleType,response[0].VehicleTypeId,response[0].VehicleType);
            this.setDropdown(this.VehicleNo,response[0].VehicleId,response[0].VehicleNo);
            this.setDropdown(this.PickupLocation,response[0].Origin,response[0].Origin);
            this.setDropdown(this.DeliveryLocation,response[0].Destination,response[0].Destination);
            this.setDropdown(this.Driver,response[0].DriverId,response[0].DriverName);
            this.GetTransportService();
          }
        },
        (error)=>{
          this.toastr.error('Failed to load Origin–Destination data.','Error');
        }
      );
  }

  setDropdown(control: any, value: any, name: any) {
    control.dropdownList = [{
      value,
      name
    }];
  }

  GetTransportService() {
    this.orderService.GetTransportServiceList().then(
    (res) => {
      this.TransportService.dropdownList = [];
      this.TransportService.dropdownList = res;
    })
    .catch((error) => {
      console.log(error);
    });
  }

  GetVehicleType(value, isScrollDown = false) {
    this.VehicleType.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.VehicleType.dropdownList.length / 20) + 1;
    }
    this.orderService.GetVehicleTypeselect2(value, pageNo).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.VehicleType.dropdownList.length) {
        dropdownList = dropdownList.concat(this.VehicleType.dropdownList);
        this.VehicleType = { ...this.VehicleType, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.VehicleType = { ...this.VehicleType, dropdownList: [...dropdownList] });
      this.VehicleType.isSearch = false;
    }).catch(error => {
      this.VehicleType.isSearch = false;
    })
  }

  // GetPickupLocationList(value, isScrollDown = false) {
  //   this.PickupLocation.isSearch = true;
  //   let pageNo = 1;
  //   if (isScrollDown === true) {
  //     pageNo = Math.ceil(this.PickupLocation.dropdownList.length / 20) + 1;
  //   }
  //   this.orderService.NewGetOriginDestination(value, 'Origin').then(res => {
  //     let dropdownList = [...res];
  //     if (isScrollDown && res.Total > this.PickupLocation.dropdownList.length) {
  //       dropdownList = dropdownList.concat(this.PickupLocation.dropdownList);
  //       this.PickupLocation = { ...this.PickupLocation, dropdownList: [...dropdownList] };
  //     }
  //     !isScrollDown && (this.PickupLocation = { ...this.PickupLocation, dropdownList: [...dropdownList] });
  //     this.PickupLocation.isSearch = false;
  //   }).catch(error => {
  //     this.PickupLocation.isSearch = false;
  //   })
  // }

  GetPickupLocationList(value, isScrollDown = false, index: number) {
    const field = this.orders[index].pickupLocationField;
    field.isSearch = true;

    this.orderService.NewGetOriginDestination(value, 'Origin')
      .then(res => {
        field.dropdownList = res;
        field.isSearch = false;
      })
      .catch(() => {
        field.isSearch = false;
      });
  }



  GetDeliveryLocationList(value, isScrollDown = false) {
    this.DeliveryLocation.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.DeliveryLocation.dropdownList.length / 20) + 1;
    }
    this.orderService.NewGetOriginDestination(value, 'Destination').then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.DeliveryLocation.dropdownList.length) {
        dropdownList = dropdownList.concat(this.DeliveryLocation.dropdownList);
        this.DeliveryLocation = { ...this.DeliveryLocation, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.DeliveryLocation = { ...this.DeliveryLocation, dropdownList: [...dropdownList] });
      this.DeliveryLocation.isSearch = false;
    }).catch(error => {
      this.DeliveryLocation.isSearch = false;
    })
  }

  GetVehicleList(value, isScrollDown = false) {
    this.VehicleNo.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.VehicleNo.dropdownList.length / 20) + 1;
    }
    this.orderService.NewVehicleNoSelect2(value, pageNo).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.VehicleNo.dropdownList.length) {
        dropdownList = dropdownList.concat(this.VehicleNo.dropdownList);
        this.VehicleNo = { ...this.VehicleNo, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.VehicleNo = { ...this.VehicleNo, dropdownList: [...dropdownList] });
      this.VehicleNo.isSearch = false;
    }).catch(error => {
      this.VehicleNo.isSearch = false;
    })
  }

  GetDriverList(value, isScrollDown = false) {
    this.Driver.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Driver.dropdownList.length / 20) + 1;
    }
    this.orderService.GetDriverListFromOpRept(value, pageNo,this.TenantId).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Driver.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Driver.dropdownList);
        this.Driver = { ...this.Driver, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Driver = { ...this.Driver, dropdownList: [...dropdownList] });
      this.Driver.isSearch = false;
    }).catch(error => {
      this.Driver.isSearch = false;
    })
  }

  GetCustomerList(value, isScrollDown = false) {
    this.Customer.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Customer.dropdownList.length / 20) + 1;
    }
    this.orderService.SalesCustomerSelect2(value, pageNo,this.TenantId).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Customer.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Customer.dropdownList);
        this.Customer = { ...this.Customer, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Customer = { ...this.Customer, dropdownList: [...dropdownList] });
      this.Customer.isSearch = false;
    }).catch(error => {
      this.Customer.isSearch = false;
    })
  }

  getChangedValue(value, field,index: number){
    const order = this.orders[index];

    if (value) {
      if (
        field.dataField === 'TransportService' ||
        field.dataField === 'ContainerNo' ||
        field.dataField === 'TripDate' ||
        field.dataField === 'SealNo'
      ) {
        order[field.dataField] = value;
      } else if (field.dataField === 'DieselTaken' || field.dataField === 'Weight') {
        order[field.dataField] = Number(value);
      } else {
        order[field.dataField] = value.value;
      }
    } else {
      order[field.dataField] = null;
    }

    console.log('this.orders',this.orders);
  }

  Save() {
    this.isFormSubmitY=true;

    const requiredFields = [
      { key: 'TripDate', label: 'Trip Date' },
      { key: 'Customer', label: 'Customer' },
      { key: 'TransportService', label: 'Transport Service' },
      { key: 'VehicleType', label: 'Vehicle Type' },
      { key: 'PickupLocation', label: 'From Location' },
      { key: 'DeliveryLocation', label: 'To Location' },
      { key: 'VehicleNo', label: 'Vehicle No' },
      { key: 'ContainerNo', label: 'Container No' },
      { key: 'Weight', label: 'Weight' }
    ];

    const containerRegex = /^[A-Z]{3}U\d{7}$/;

    for (let i = 0; i < this.orders.length; i++) {
      const order = this.orders[i];
      const row = i + 1;

      for (const field of requiredFields) {
        if (!order[field.key]) {
          this.toastr.warning(
            `Select ${field.label} at row ${row}`,
            'Warning'
          );
          return;
        }
      }

      if (order.ContainerNo && !containerRegex.test(order.ContainerNo)) {
        this.toastr.warning(
          `Invalid container number at row ${row}. Format: "XXXU0000000"
          (3 alphabets + U + 7 digits)`,
          'Warning'
        );
        return;
      }
    }
    
    var payload: any = [];
    for (let index = 0; index < this.orders.length; index++) {
      const element = this.orders[index];
      var obj: any = {};
      obj.TripDate = element.TripDate;
      obj.CustomerId = element.Customer;
      obj.TransportServiceId = element.TransportService;
      obj.VehicleTypeId = element.VehicleType;
      obj.Origin = element.PickupLocation;
      obj.Destination = element.DeliveryLocation;
      obj.VehicleId = element.VehicleNo;
      obj.Weight = element.Weight;
      obj.ContainerNo = element.ContainerNo;
      obj.SealNo = element.SealNo ? element.SealNo : '';
      obj.Scan = element.Scan ? element.Scan : '';
      obj.DieselTaken = element.DieselTaken ? element.DieselTaken : 0;
      obj.DriverId = element.Driver;
      obj.CompanyId = this.CompanyId;
      obj.UserId = this.userId;

      payload.push(obj);
    }

    console.log('save payload',payload);

    setTimeout(() => {
      Helpers.setLoading(true);
      this._appService
        .Post("Document", "NewOCRAutomateTripProcessManual", payload)
        .subscribe(
          async (response: any[]) => {
            const successfulItems = response.filter(item => item.isDone === 'OK');
            const failedItems = response.filter(item => item.Reason !== 'OK');

            if (successfulItems.length > 0) {
              this.toastr.success('Data saved successfully.', 'Ok');
              this.OnRefreshParent.emit('true');
              this.Cancel();
            }

            setTimeout(() => {
              if (failedItems.length > 0) {
                const errorMessages = failedItems
                  .map((msg, idx) => `Error ${idx + 1}: ${msg.Reason.replace(/\\,/g, ',')}`)
                  .join('\n');

                this.toastr.error(errorMessages, 'Error');
              }
            }, 1000);

            Helpers.setLoading(false);
          },
          async (err) => {
            this.toastr.error(
              "Error occurred while saving data !",
              "error"
            );
            Helpers.setLoading(false);
          }
        );
    }, 1000);

  }

  addNewOrder() {
    this.orders.push(this.createEmptyOrder());
  }

  removeOrder(index: number) {
    if (this.orders.length <= 1) {
      return;
    }
    this.orders.splice(index, 1);
  }

}
